/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfSuccess
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfSuccess {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfSuccess
     */
    Success: boolean;
    /**
     * 
     * @type {object}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfSuccess
     */
    Data: object;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfSuccess
     */
    Error?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfSuccess interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfSuccess(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfSuccess {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfSuccessFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfSuccess {
    return FxGamesLibWebRpcContractsFxGamesResponseOfSuccessFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfSuccess {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': json['Data'],
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfSuccessToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfSuccess {
    return FxGamesLibWebRpcContractsFxGamesResponseOfSuccessToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfSuccessToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfSuccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': value['Data'],
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}

